import {
  ref,
  nextTick,
} from 'vue';
import {
  formatNumberLocale,
  parseNumberLocale,
  getLocaleSeparators,
} from '@/shared/utils/locale_number_utils.js';

export function useLocaleNumberInput(precision = null) {
  const isFocused = ref(false);
  const inputRef = ref(null);

  const formatter = (val) => {
    if (isFocused.value) {
      const { decimalSeparator } = getLocaleSeparators();
      return String(val ?? '').replace('.', decimalSeparator);
    }
    return formatNumberLocale(val, precision ?? undefined);
  };

  const parser = (val) => {
    const result = parseNumberLocale(val);
    return result !== undefined ? String(result) : '';
  };

  const handleFocus = () => {
    isFocused.value = true;
    nextTick(() => {
      const input = inputRef.value?.$el?.querySelector('input');
      if (input && input.value) {
        const { groupSeparator, decimalSeparator } = getLocaleSeparators();
        const raw = input.value.replaceAll(groupSeparator, '');
        input.value = raw.replace('.', decimalSeparator);
      }
    });
  };

  const handleBlur = (modelValue) => {
    isFocused.value = false;
    nextTick(() => {
      const input = inputRef.value?.$el?.querySelector('input');
      if (input) {
        input.value = formatNumberLocale(modelValue, precision ?? undefined);
      }
    });
  };

  return { inputRef, formatter, parser, handleFocus, handleBlur };
}
